const $Type = require('../../Type');

function getdata (dataset, el) {
  let data = el.dataset;
  return data[dataset];
};

function setdata (object, el) {
  Object.keys(object).map(key => {
    el.dataset[key] = object[key];
  });
};

const dataset = function(dataset, el) {
  if ($Type.isString(dataset)) {
    return getdata(dataset, el);
  } else {
    setdata(dataset, el);
  }
}

function getprop(prop, el) {
  return el.getAttribute(prop);
};

function setprop (object, el) {
  Object.keys(object).map(key => {
    el.setAttribute(key, object[key]);
  });
};

const prop = function(prop, el) {
  if ($Type.isString(prop)) {
    return getprop(prop, el);
  } else {
    setprop(prop, el);
  }
}

const m = {
  dataset,
  prop
}

module.exports = m;